import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import { TariffDirection } from '../../../../api/Optimise';
import { EnergyIcon, FormattedTariffValues } from '../../../../ui';
import { StyledHr, StyledKeylineDiv } from '../../../../ui/Styled';
import getRecommendedTariffValues from '../../../../utils/getRecommendedTariffValues';
import toTitleCase from '../../../../utils/toTitleCase';

const StyledLi = styled.li`
  list-style: none;
  margin-bottom: 8px;
`;

const TariffItemPrimary = ({ tariff, showSupplier = false, hasTariffBeenRecentlyUpdated = false }) => {
  const theme = useTheme();
  const history = useHistory();
  const { exportValue, importValue } = getRecommendedTariffValues(tariff);

  return (
    <>
      <div>
        <div className="d-flex">
          <EnergyIcon direction={TariffDirection.IMPORT} />
          <div className="pl-2">
            {showSupplier && (
              <StyledLi>
                Import energy provider: {toTitleCase(tariff.tariff_combination.import_tariff_supplier_name)}
              </StyledLi>
            )}
            <StyledLi>Import tariff: {toTitleCase(tariff.tariff_combination.import_tariff_name)}</StyledLi>
          </div>
        </div>
        <StyledHr />
        <div className="d-flex">
          <EnergyIcon direction={TariffDirection.EXPORT} />
          <div className="pl-2">
            {showSupplier && (
              <StyledLi>
                Export energy provider: {toTitleCase(tariff.tariff_combination.export_tariff_supplier_name)}
              </StyledLi>
            )}
            <StyledLi>Export tariff: {toTitleCase(tariff.tariff_combination.export_tariff_name)}</StyledLi>
          </div>
        </div>
      </div>

      {!hasTariffBeenRecentlyUpdated && <div className="mb-4" />}

      {!hasTariffBeenRecentlyUpdated && (
        <>
          <StyledKeylineDiv>
            <p>
              <strong>With this tariff and {theme.language.appName}, your annual bill would have been:</strong>
            </p>
            <p className="mb-0">
              <FormattedTariffValues exportValue={exportValue} importValue={importValue} />
            </p>
          </StyledKeylineDiv>
          <Button
            onClick={() => {
              window.scrollTo(0, 0);
              return history.push(
                `/app/tariffs/recommended/${tariff.tariff_combination.tariff_standard_combination_id}`
              );
            }}
            variant="secondary"
            className="mt-3"
            block
          >
            View tariff details
          </Button>
        </>
      )}
    </>
  );
};

export default TariffItemPrimary;
